import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const ProfileTab = ({ user, profileForm, setProfileForm, onSubmit }) => (
  <div className="max-w-lg">
    <div className="bg-white rounded-xl border border-gray-100 p-6">
      <h3 className="font-semibold text-gray-900 mb-4">Edit Profile</h3>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <Label className="text-sm text-gray-700">Full Name</Label>
          <Input data-testid="profile-name" value={profileForm.name} onChange={e => setProfileForm({ ...profileForm, name: e.target.value })} className="mt-1" />
        </div>
        <div>
          <Label className="text-sm text-gray-700">Phone</Label>
          <Input data-testid="profile-phone" value={profileForm.phone} onChange={e => setProfileForm({ ...profileForm, phone: e.target.value })} className="mt-1" />
        </div>
        <div>
          <Label className="text-sm text-gray-700">Email</Label>
          <Input value={user.email} disabled className="mt-1 bg-gray-50" />
        </div>
        <div>
          <Label className="text-sm text-gray-700">Role</Label>
          <Input value={user.role} disabled className="mt-1 bg-gray-50 capitalize" />
        </div>
        <Button type="submit" data-testid="profile-save" className="bg-warm-700 hover:bg-warm-800 text-white rounded-xl">
          Save Changes
        </Button>
      </form>
    </div>
  </div>
);
